<template>
  <div>
    <div @click="prev" v-if="!atTop" class="h-screen-1/2 hidden md:block fixed left-0 right-0 top-0 cursor-n-resize z-5"></div>
    <div @click="advance" class="h-screen-1/2 hidden md:block fixed left-0 right-0 bottom-0 cursor-s-resize z-5"></div>

    <nav class="z-10 xs-hide sm-hide md-fixed left-0 top-0 mt4 ml2">
      <ul class="list-reset m0">
        <li v-for="row in rows" :class="active(row.id)" class="h3 max-w-list">
          <a :href="anchor(row.id)" @click.prevent="to(row.id)">{{ row.title }}</a>
        </li>
      </ul>
    </nav>

    <article class="infos mb-12">
      <template v-for="row in rows">
        <section :id="row.id" ref="anchors" class="pb3 sm-pb4 md-info-height md-flex flex-wrap items-center relative scroll-mt-14">
          <div class="w-full max-width-2 mx-auto relative z-10">
            <h2 class="h4 regular underline m0 md-hide lg-hide">{{ row.title }}</h2>
            <div class="relative cms">
              <div v-html="row.content" class="justify"></div>
            </div>
          </div>

          <v-waypoint @waypoint-in="waypointIn(row.id)" class="absolute waypoint"></v-waypoint>
          <v-waypoint @waypoint-in="waypointIn(row.id)" class="absolute waypoint-b"></v-waypoint>

          <div v-if="row.images && row.images[0]" class="block lg:absolute right-0 top-0 w-aside mx-auto mt-4">
            <div class="my-8 lg:my-0 lg:aspect-square w-auto h-auto max-width-2 lg:max-w-full max-h-full mx-auto object-contain sm:px-8 lg:px-0">
              <responsive-image :src="row.images[0]" class="w-full h-full object-contain" />
            </div>
          </div>
          <div v-if="row.images && row.images[1]" class="block lg:absolute left-0 bottom-24 w-aside mx-auto">
            <div class="my-8 lg:my-0 lg:aspect-square w-auto h-auto max-width-2 lg:max-w-full max-h-full mx-auto object-contain sm:px-8 lg:px-0">
              <responsive-image :src="row.images[1]" class="w-full h-full object-contain" />
            </div>
          </div>
          <div v-if="row.images && row.images[2]" class="block lg:absolute right-0 bottom-24 w-aside mx-auto">
            <div class="my-8 lg:my-0 lg:aspect-square w-auto h-auto max-width-2 lg:max-w-full max-h-full mx-auto object-contain sm:px-8 lg:px-0">
              <responsive-image :src="row.images[2]" class="w-full h-full object-contain" />
            </div>
          </div>
        </section>
      </template>
    </article>

    <div v-if="contact" class="sm-fixed sm-max-width-footer left-0 bottom-0 pt1 sm-p2 z-10">
      <p v-text="contact" class="m0 lg:text-xl"></p>
    </div>
  </div>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'information',
    metaInfo: { title: 'Information · Maich Swift Architects' },
    data () {
      return {
        y: 0,
        listener: 0,
        current: ''
      }
    },
    computed: {
      atTop () {
        return this.y < 80
      },
      slug () {
        return this.$route.meta.slug
      },
      page () {
        return this.$store.state.pages[this.slug] || {}
      },
      rows () {
        if (!this.page.acf) return []

        return this.page.acf.rows.map((p) => {
          p.id = p.title.toLowerCase().replace(/\s/g, '-')
          return p
        })
      },
      contact () {
        return this.$store.state.pages['home'] &&
          this.$store.state.pages['home'].acf &&
          this.$store.state.pages['home'].acf.contact
      },
      anchors () {
        return this.$refs.anchors
      }
    },
    methods: {
      to (id) {
        if (!id) return
        const el = document.getElementById(id)

        if (el) {
          el.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          })
        }
      },
      anchor (id) {
        return `#${id}`
      },
      active (id) {
        return id === this.current && 'router-link-active'
      },
      waypointIn (id) {
        this.current = id
      },

      prev () {
        for (let i = this.anchors.length - 1; i > 0; i--) {
          if (this.anchors[i].getBoundingClientRect().top < 0) {
            this.anchors[i].scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
            return
          }

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
      },
      advance () {
        const headings = document.querySelectorAll('.cms h2')
        const h = window.innerHeight * 0.8

        let ne
        let nt
        for (const h2 of headings) {
          const ntt = h2.getBoundingClientRect().top
          if (ntt > h * 0.4) {
            ne = h2
            nt = ntt
            break
          }
        }

        for (let el of this.anchors) {
          const et = el.getBoundingClientRect().top
          if (nt < et && ne) {
            ne.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
            return
          }
          if (et > h) {
            el.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
            return
          }
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    beforeRouteEnter (to, from, next) {
      const { slug } = to.meta
      store.dispatch('getPage', slug).then(() => {
        next()
      })
    },
    mounted () {
      console.log(this.page)
      this.listener = window.addEventListener('scroll', () => {
        this.y = window.scrollY
      })
    },
    onUnmounted () {
      window.removeEventListener(this.listener)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Information.vue